import React from "react";
import { Avatar, Box, Typography } from "@mui/material";

const AVATAR_COLORS = [
  "#ff5722",
  "#7c4dff",
  "#2196f3",
  "#4caf50",
  "#ff9800",
  "#e91e63",
  "#009688",
  "#795548",
];

const getInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const getColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const hexToRgba = (hex, alpha) => {
  const normalized = hex.replace("#", "");
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const InitialsAvatar = ({
  name,
  showName = true,
  textColor = "inherit",
  variant = "default",
  size = 32,
}) => {
  const color = getColor(name);
  const isSoft = variant === "soft";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      <Avatar
        sx={{
          width: size,
          height: size,
          fontSize: size <= 32 ? "0.75rem" : "0.85rem",
          fontWeight: 600,
          bgcolor: isSoft ? hexToRgba(color, 0.15) : color,
          color: isSoft ? color : "#fff",
        }}
      >
        {getInitials(name)}
      </Avatar>
      {showName && (
        <Typography variant="body2" sx={{ color: textColor, fontWeight: 500 }}>
          {name || "—"}
        </Typography>
      )}
    </Box>
  );
};

export default InitialsAvatar;
